<div class="resetpage">
  <div class="row m-0">
    <div class="col-sm-9 m-0 col-md-7 col-lg-5 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <h5 class="card-title text-center">Set New Password</h5>
          <div>
            <form
              method="post"
              autocomplete="off"
              action=""
              [formGroup]="ResponseResetForm"
              (ngSubmit)="ResetPassword(ResponseResetForm)">
              <div class="form-group">
                <input
                  _ngcontent-c0=""
                  class="form-control form-control-lg"
                  placeholder="Password"
                  type="password"
                  id="resetPassword"
                  formControlName="newPassword" />
                <div
                  class="text-danger"
                  *ngIf="
                    ResponseResetForm.get('newPassword').invalid &&
                    (ResponseResetForm.get('newPassword').touched ||
                      ResponseResetForm.get('newPassword').dirty)
                  ">
                  <div *ngIf="ResponseResetForm.get('newPassword').hasError('required')">
                    Password is required
                  </div>
                  <!-- <div
                                      class="text-danger"
                                      *ngIf="ResponseResetForm.get('newPassword').hasError('required')">
                                      Password must be at least 8 characters long.
                                    </div> -->
                  <div
                    class="text-danger"
                    *ngIf="ResponseResetForm.get('newPassword').hasError('passwordStrength')">
                    {{ ResponseResetForm.get('newPassword').errors['passwordStrength'] }}
                  </div>
                </div>
                <!-- <span *ngIf="!ResponseResetForm.get('newPassword').valid && !IsResetFormValid"
                                    class="errors">Password is required with atleast 8 characters.</span> -->
              </div>
              <div class="form-group">
                <input
                  _ngcontent-c0=""
                  class="form-control form-control-lg"
                  placeholder="Confirm Password"
                  type="password"
                  id="cpassword"
                  formControlName="confirmPassword" />
                <!-- <span
                                    *ngIf="ResponseResetForm.get('confirmPassword').valid && (ResponseResetForm.get('confirmPassword').value != ResponseResetForm.get('newPassword').value) && !IsResetFormValid"
                                    class="errors">Confirm Password does not match with password.</span> -->
                <p
                  class="text-danger"
                  *ngIf="
                    ResponseResetForm.get('confirmPassword').hasError('required') &&
                    ResponseResetForm.get('confirmPassword').touched
                  ">
                  Confirm Password is required
                </p>
                <p
                  class="text-danger"
                  *ngIf="
                    this.ResponseResetForm.get('newPassword').value !==
                      this.ResponseResetForm.get('confirmPassword').value &&
                    ResponseResetForm.get('confirmPassword').dirty
                  ">
                  Confirm Password does not match with password.
                </p>
              </div>
              <div class="form-group">
                <div>
                  <button
                    [disabled]="
                      this.ResponseResetForm.get('newPassword').value == '' ||
                      this.ResponseResetForm.get('confirmPassword').value == '' ||
                      this.ResponseResetForm.get('newPassword').value !==
                        this.ResponseResetForm.get('confirmPassword').value ||
                      ResponseResetForm.get('newPassword').hasError('passwordStrength')
                    "
                    type="submit"
                    class="btn btn-danger">
                    Update Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
